'use client';
export { Grid, GridItem, SimpleGrid } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map